<div class="form__group field">
  <label for="{{ id }}" class="form__label">{{ label }}</label>
  <div class="rt-card-img" *ngIf="isUploaded">
    <img [ngStyle]="{'object-fit': viewType}" class="upload-doc-img"
      [src]="imagePreview ? imagePreview : '/assets/image/img-thumb.png'" alt="image" />
    <span *ngIf="isUploaded" class="material-icons img-close" (click)="clearInput();">
      clear
    </span>
  </div>
  <div class="rt-card" *ngIf="!isUploaded">
    <div class="img-place-holder"></div>
    <input type="file" class="file-upload" id="{{ id }}" (change)="upload($event)" />
    <button class="rt-btn">
      <span class="material-icons">
        perm_media
      </span>
      {{buttonName}}
    </button>
  </div>
</div>